export default "__VITE_ASSET__Cxaa6E5O__"